import Record from "slotworks/model/gameplay/records/record";

export default class BuyoutRecord extends Record {
    
    public freespinsTriggered: boolean = false;
    public freespinsWon: number;

    public remain: number;
    public totalBetCredits: number = 0;
    public totalCreditsWon: number = 0;
}